module.exports = __webpack_public_path__ + "static/media/img-location-kaohsiung-en.6005dd1c.svg";